var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('UserNav'),_c('div',{staticClass:"h2 py-3 text-center"},[_vm._v("งานขอคุณ")]),_c('div',{staticClass:"px-3"},[_c('div',{staticClass:"card shadow-lg border border-0"},[_c('div',{staticClass:"card-body"},[_c('Noti')],1)])]),_c('FooterMenu',{attrs:{"activeTab":_vm.activeTab},on:{"menu-click":_vm.tabChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }